"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
function CalendarManagementModal(_a) {
    var rentalId = _a.rentalId, rentalUnitId = _a.rentalUnitId;
    var modalRef = (0, react_1.useRef)(null);
    var root = document.querySelector("#chat") || document.querySelector("#chat-direct");
    var token = root === null || root === void 0 ? void 0 : root.getAttribute("data-user-jwt-token");
    var handleDialogClick = function (e) {
        var _a, _b;
        if (modalRef.current) {
            var dialogDimensions = (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            // closes modal when clicked on background
            if (e.clientX < dialogDimensions.left ||
                e.clientX > dialogDimensions.right ||
                e.clientY < dialogDimensions.top ||
                e.clientY > dialogDimensions.bottom) {
                (_b = modalRef.current) === null || _b === void 0 ? void 0 : _b.close();
            }
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn btn--ss btn--tertiary pr", onClick: function () { var _a; return (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.showModal(); } },
            react_1.default.createElement("svg", { className: "icon mb-0", width: "18", height: "18" },
                react_1.default.createElement("use", { href: "#calendar" })),
            window.Translator.trans("calendar.title", {}, "js")),
        react_1.default.createElement("dialog", { className: "border p-3", ref: modalRef, onClick: handleDialogClick },
            react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-start gap-2" },
                react_1.default.createElement("h2", { className: "h6 p-0 strong d-flex gap-2 align-items-center" }, window.Translator.trans("calendar.title", {}, "js")),
                react_1.default.createElement("button", { onClick: function () { var _a; return (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.close(); } },
                    react_1.default.createElement("svg", { className: "icon mb-0", width: "18", height: "18" },
                        react_1.default.createElement("use", { href: "#close" })))),
            react_1.default.createElement("p4g-management", __assign({ class: "mt-3", token: token }, (rentalUnitId ? { ids: rentalUnitId } : { parents: rentalId }))))));
}
exports.default = CalendarManagementModal;
